import { __awaiter, __generator } from "tslib";
import { fetchGroupAttributes } from '@gn-audio/core/api/product-catalogue/fetch-group-attributes';
import { fetchProductsBySkus } from '@gn-audio/core/api/product-catalogue/fetch-products-by-skus';
/**
 * Checks whether a product is allowing to have a service for a locale
 * @param sku Product SKU to check (External reference ID)
 * @param serviceType Type of the service attached to the master product
 * @returns Boolean value indicating whether service is allowed for product on a specific locale
 * @async
 */
export var isProductServiceAllowedForLocale = function (sku, serviceType) { return __awaiter(void 0, void 0, void 0, function () {
    var serviceKeys, products, groupId, productGroup, serviceAttribute;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                serviceKeys = {
                    'GIFT_WRAPPING': "Product_GiftWrapping" /* ProductAttributeKey.GiftWrapping */,
                    'ENGRAVING': "Product_Engraving" /* ProductAttributeKey.Engraving */,
                };
                return [4 /*yield*/, fetchProductsBySkus([sku])];
            case 1:
                products = _b.sent();
                if (!(products === null || products === void 0 ? void 0 : products.length)) {
                    return [2 /*return*/, false];
                }
                groupId = products[0].groupId;
                return [4 /*yield*/, fetchGroupAttributes(groupId, "available" /* IncludeType.Available */)];
            case 2:
                productGroup = _b.sent();
                if (productGroup === null) {
                    return [2 /*return*/, false];
                }
                serviceAttribute = (_a = productGroup.attributes) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.key === serviceKeys[serviceType]; });
                return [2 /*return*/, !!serviceAttribute && serviceAttribute.value === 'True'];
        }
    });
}); };
